export const iconFontAwesomeMapsPersonWalkingWithCane = (
	<i className="fa-solid fa-person-walking-with-cane"></i>
);
